import { generateHTML } from '@tiptap/core';

import { RICHTEXT_SETTINGS, ViewProps } from './info-box.constants';
import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import {
  InfoBoxViewTextBox,
  InfoBoxViewNote,
  InfoBoxColouredBox,
  InfoBoxStatementBox,
  InfoBoxInstructionBox,
  InfoBoxStyleBoxSpeech,
} from './info-box-view';
import {
  BORDER_STYLE_BOX,
  BORDER_STYLE_INSTRUCTION,
  BORDER_STYLE_NONE,
  BORDER_STYLE_NOTE,
  BORDER_STYLE_SPEECH,
  BORDER_STYLE_STATEMENT,
} from 'global/constants';

const InfoBoxPrint = ({ id, properties }: ViewProps) => {
  const extensions = getExtensions(RICHTEXT_SETTINGS);
  const richtext = isRichtextEmpty(properties.richtext)
    ? ''
    : generateHTML(properties.richtext, extensions);
  const style = properties.style;

  return (
    <>
      {style?.border === BORDER_STYLE_NOTE && (
        <InfoBoxViewNote id={id} richtext={richtext} />
      )}

      {style?.border === BORDER_STYLE_NONE && (
        <InfoBoxViewTextBox id={id} style={style} richtext={richtext} />
      )}

      {style?.border === BORDER_STYLE_STATEMENT && (
        <InfoBoxStatementBox id={id} style={style} richtext={richtext} />
      )}

      {style?.border === BORDER_STYLE_INSTRUCTION && (
        <InfoBoxInstructionBox id={id} style={style} richtext={richtext} />
      )}

      {style?.border === BORDER_STYLE_BOX && (
        <InfoBoxColouredBox id={id} style={style} richtext={richtext} />
      )}

      {style?.border === BORDER_STYLE_SPEECH && (
        <InfoBoxStyleBoxSpeech id={id} style={style} richtext={richtext} />
      )}
    </>
  );
};

export default InfoBoxPrint;
